import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;


export const getAssessment = async (appointmentId, assessmentKey) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/appointments/${appointmentId}/assessments/${assessmentKey}`,
      {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token")}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching assessment:",
      error.response?.data || error.message
    );
    throw error;
  }
};


export const saveAssessment = async (appointmentId, data) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/appointments/${appointmentId}/assessments`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("token")}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error saving assessment:",
      error.response?.data || error.message
    );
    throw error;
  }
};


export const getAllPatientAssessments = async (drId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/doctors/${drId}/assessments`,
      {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token")}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching all patient assessments:",
      error.response?.data || error.message
    );
    throw error;
  }
};



// Get all assessment master records
export const getAssessments = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/assessment`,
      {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token")}`
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching assessments:",
      error.response?.data || error.message
    );
    throw error;
  }
};


// Create new assessment
export const createAssessment = async (data) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/assessment`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("token")}`
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error creating assessment:",
      error.response?.data || error.message
    );
    throw error;
  }
};


// Assign assessment
export const assignAssessment = async (data) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/assigned-assessments`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error assigning assessment:", error);
    throw error;
  }
};


// Get assigned assessments by customer ID
export const getAssignedAssessments = async (doctorId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/assigned-assessments/doctor/${doctorId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching assigned assessments:",
      error.response?.data || error.message
    );
    throw error;
  }
};


// Mark assessment as completed
export const completeAssignedAssessment = async (
  customerId,
  appointmentId,
  assessmentKey
) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/assigned-assessments/customer/${customerId}/appointment/${appointmentId}/${assessmentKey}/complete`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error completing assessment:", error);
    throw error;
  }
};

// Get assigned assessments by customer ID
export const getAssignedAssessmentsByCustomer = async (customerId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/assigned-assessments/customer/${customerId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching customer assigned assessments:",
      error.response?.data || error.message
    );
    throw error;
  }
};